import type { FocusEvent, MouseEvent } from "react";
import { call } from "shelving";
import { Button, type ButtonProps } from "./Button.js";
import { NOTICES } from "./Notices.js";

export function CopyText({ copy }: { copy: string }) {
	return <textarea className="input" onClick={onClick} onFocus={onFocus} children={copy} readOnly rows={1} />;
}

function onFocus({ currentTarget }: FocusEvent<HTMLTextAreaElement>): void {
	currentTarget.select();
}

function onClick({ currentTarget }: MouseEvent<HTMLTextAreaElement>): void {
	currentTarget.select();
	copyElementText(currentTarget);
}

export function CopyButton({ copy, ...props }: { copy: string } & ButtonProps): React.ReactElement {
	return <Button {...props} onClick={() => call(copyString, copy)} />;
}

/** Copy the text content of an HTML element to the clipboard. */
export function copyElementText(el: HTMLTextAreaElement) {
	el.select();
	if (el.textContent) call(copyString, el.textContent);
}

/** Copy a string to the clipboard. */
export async function copyString(str: string) {
	await navigator.clipboard.writeText(str);
	NOTICES.success("Copied to clipboard");
}
